import ReservationEditPicker from "./customers-orders/ReservationEditPicker";
import OrderUpdateConfirmationModal from "./customers-orders/OrderUpdateConfirmationModal";
import FormValidation from '../modules/FormValidation';
export default class CustomersOrdersEditPage {
    constructor() {
        this.page = document.querySelector('.page.customers-orders-edit');
        if (!this.page) {
            return;
        }
        this.ajaxApiUrl = window.localize_script.admin_ajax;
        this.initViewData();
        this.initForm();
        this.initReservationForms();
        this.updateConfirmationModal = new OrderUpdateConfirmationModal();
    }
    initViewData() {
        const viewDataElement = document.getElementById('view-data');
        if (viewDataElement) {
            try {
                this.viewData = JSON.parse(viewDataElement.textContent || '{}');
            }
            catch (error) {
                this.viewData = {
                    adults_price: 0,
                    teenagers_price: 0,
                    kids_price: 0,
                    units: 'Units'
                };
            }
        }
    }
    initForm() {
        this.form = this.page.querySelector('#order-edit-form');
        if (!this.form) {
            return;
        }
        this.formValidation = new FormValidation(this.form, {
            showErrorsOnSubmit: true,
            clearErrorsOnFocus: true,
            generalErrorSelector: '#order-error-message'
        });
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.handleFormSubmit();
        });
    }
    initReservationForms() {
        this.reservationPickers = this.page.querySelectorAll('[data-reservation-picker]');
        if (this.reservationPickers.length) {
            this.reservationPickers.forEach((element) => {
                new ReservationEditPicker(element);
            });
        }
    }
    getErrorMessage(key) {
        var _a;
        return ((_a = this.form) === null || _a === void 0 ? void 0 : _a.getAttribute(`data-error-${key}`)) || '';
    }
    handleFormSubmit() {
        this.formValidation.clearAllErrors();
        const submitButton = this.form.querySelector('button[type="submit"]');
        const originalText = (submitButton === null || submitButton === void 0 ? void 0 : submitButton.textContent) || '';
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Saving...';
        }
        const formData = new FormData(this.form);
        fetch(this.ajaxApiUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
            .then(response => response.json())
            .then(data => {
            var _a, _b;
            console.log(data);
            if (data.success) {
                if (data.data.redirect_url && data.data.title) {
                    this.updateConfirmationModal.show(data.data.title, data.data.redirect_url);
                }
                else if (data.data.redirect_url) {
                    window.location.href = data.data.redirect_url;
                }
            }
            else {
                if ((_a = data.data) === null || _a === void 0 ? void 0 : _a.errors) {
                    this.formValidation.showErrors(data);
                }
                else {
                    this.formValidation.showGeneralError(((_b = data.data) === null || _b === void 0 ? void 0 : _b.message) ||
                        this.getErrorMessage('process') ||
                        'An error occurred while updating the order.');
                }
                if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.textContent = originalText;
                }
            }
        })
            .catch(error => {
            this.formValidation.showGeneralError(this.getErrorMessage('generic') ||
                'An error occurred. Please try again later.');
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = originalText;
            }
        });
    }
}
